module.exports = __webpack_public_path__ + "img/horiz_logo.1c37681f.png";